import NavMenu from './Nav Menu';
import Homepage from './Homepage';
import PropertyDetails from './Property Details';
import SmoothScroll from './SmoothScroll';
import Contact from './contact';

let App = {
    init() {
        window.NavMenu = new NavMenu();
        window.Homepage = new Homepage();
        window.PropertyDetails = new PropertyDetails();
        window.Contact = new Contact()
        if(document.querySelector('.anchor')) {
            window.SmoothScroll = new SmoothScroll();
        }
        document.querySelector('body').classList.remove('loading');
        Array.from(document.querySelectorAll('label.placeholder'))
            .map((l)=>l.parentElement.querySelector('select'))
            .forEach((s)=>this.selectPlaceholder(s));
    },
    check(e){
        e.preventDefault();
        let check = e.srcElement.previousSibling;
        check.checked = !check.checked;
    },
    selectPlaceholder(select){
        let placeholder = select.parentElement.querySelector('label.placeholder');
        if(select.options[select.selectedIndex].value === ''){
            placeholder.removeAttribute('hidden');
        } else {
            placeholder.setAttribute('hidden', '');
        }
    },
};

document.addEventListener('DOMContentLoaded', function(){
    window.App = App;
    window.App.init();
});


// WEBPACK FOOTER //
// ./resources/assets/js/App.js